import vuetifyToast from 'vuetify-toast'

export const setCreate = (user) => {
  vuetifyToast.show({
  text: 'Funcionalidad no implantada',
  color: 'success',
  timeout: 2000,
  icon: 'warning'
})
}

export const setUpdate = (user) => {
 vuetifyToast.show({
  text: 'Funcionalidad no implantada',
  color: 'success',
  timeout: 2000,
  icon: 'warning'
})
}

export const setDelete = (id) => {
  vuetifyToast.show({
  text: 'Funcionalidad no implantada',
  color: 'success',
  timeout: 2000,
  icon: 'warning'
})
}


